// axios
import axios from 'axios'

export default axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        'client-id': process.env.VUE_APP_CLIENT_ID,
        'client-token': process.env.VUE_APP_CLIENT_TOKEN,
    }
})
